import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for the hazmat-approval gate.
 *
 * V1 gated the "Approved?" checkbox on a field ACL over `hazmatapprovedby`
 * (lib_editrecord.pl getHazmatInfo: `getACL(... 'hazmatapprovedby' ...)`), which
 * is stricter than editing the hazmat lines themselves. We reproduce that split:
 * adding/deleting hazmat lines rides the standard LC-fields gate
 * (`order-lc-fields`), while the approval toggle has its OWN component permission.
 */
export const HAZMAT_APPROVAL_COMPONENT_ID = 'hazmat-approval';

/**
 * Whether the current user may (un)approve hazmat for hauling.
 *
 * Resolved from the admin-configured component permission crossed with the
 * user's Azure AD groups. Ships **defaultDisabled**: until an admin grants a
 * group edit access on `hazmat-approval`, the approval checkbox stays read-only
 * for everyone. Server-side enforced too (save_order_details gates a
 * `hazmatapprovedby` change on the same component).
 */
export const useCanApproveHazmat = (): boolean =>
  useResolvedAccessLevel(HAZMAT_APPROVAL_COMPONENT_ID, false, true) >= 2;
